<template>
  <div>
    <!-- 日历组件 -->
    <div class="calendar-box">
      <table class="calendar-table">
        <thead>
          <th class="fc-day-header">日</th>
          <th class="fc-day-header">一</th>
          <th class="fc-day-header">二</th>
          <th class="fc-day-header">三</th>
          <th class="fc-day-header">四</th>
          <th class="fc-day-header">五</th>
          <th class="fc-day-header">六</th>
        </thead>
        <tbody>
          <tr>
            <td
              v-for="(item, index) in calendarData"
              :key="index"
              :style="{ height: height }"
              @click="clickDay(item)"
            >
              <div
                class="includeContent"
                :class="{
                  include: item.include,
                  active: isTrue(item.date2),
                }"
              >
                <slot name="day" :row="item">
                  <div class="day">
                    <span class="d_one">{{ item.day2 }}</span>
                    <span
                      class="d_three"
                      v-if="defaultDate.indexOf(item.date2) > -1"
                      >{{ allotComboCalendarDataFilter(item.date2) }}</span
                    >
                  </div>
                </slot>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <a-modal
      wrapClassName="modalstyle"
      v-model="visible"
      :title="visibleTitle"
      :footer="null"
      :dialog-style="{ top: '15%' }"
    >
      <div v-if="sourceList.length > 0" class="source-span">
        <span
          class="item-btn-time"
          v-for="(item, index) in sourceList"
          :key="index"
        >
          <span class="time"> {{ item.allotTimePeriod }}</span>
          <span class="time">余{{ item.remainderQuantity || 0 }}</span>
          <a-button
            type="primary"
            :disabled="!item.remainderQuantity"
            @click="doConfirmation(item)"
            >预约
          </a-button>
        </span>
      </div>
      <div v-else>
        <a-empty description="暂无排号" class="auto-m" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  getAllotComboCalendar,
  allotComboCalendar,
  getAllotTimePeriod,
} from "@/api/medicalBooking";
import dayjs from "dayjs";

export default {
  name: "calendarBox",
  props: {

    userInfo1: {
      type: Object,
      default: () => ({}),
    },
    campusName: {
      type: String,
      default: "",
    },
    campusId: {
      type: String,
      default: "",
    },
    queryParams: {
      type: Object,
      default: () => ({}),
    },
    type: {
      // all 可选中显示的所有日期 portion 只能选中当前月份的数据
      type: String,
      default: "all",
    },
    defaultMonth: {
      // 默认日期
      type: Date,
      default() {
        let year = new Date().getFullYear(); // 当月年份
        let month = new Date().getMonth() + 1; // 当月月份
        return new Date(year, month - 1, 1);
      },
    },
    height: {
      //设置td高度
      type: String,
      default: "94px",
    },
  },
  data() {
    return {
      visibleTitle: "",
      visible: false,
      sourceList: [], //放号时间集合
      calendarData: [],
      activeData: null,
      defaultDate: [], // ['2022-4-1', '2022-4-7', '2022-5-7'],
      courseList: [], //['13', '13', '10'],
      allData: [],
      userInfo: {},
    };
  },
  watch: {
    // campusId: {
    //   handler(val) {
    //     if (val && this.queryParams.id) {
    //       this.getData()
    //     }
    //   }
    // },
    defaultMonth: {
      handler(val) {
        this.setDefaultValue();
        this.getCalendarDay();
        this.getData();
      },
    },
    // queryParams: {
    //   handler(val) {
    //     if (val.id) {
    //       this.getData()
    //     }
    //   },
    //   immediate: true
    // }
  },
  created() {
    this.getCalendarDay();
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));
  },
  methods: {
    allotComboCalendarDataFilter(v) {
      let newArr = this.allData.filter((e) => {
        return e.allotDate == v;
      });
      if (newArr.length > 0) {
        if (newArr[0].remainderQuantity > 0) {
          return "余" + newArr[0].remainderQuantity;
        } else {
          return "无";
        }
      } else {
        return "";
      }
    },
    isTrue(v) {
      let index = this.allData.findIndex((e) => {
        return e.allotDate === v;
      });
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    async getData() {
      if (this.queryParams.id && this.campusId) {
        const params = {
          comboId: this.queryParams && this.queryParams.id,
          currentDate: dayjs(this.defaultMonth).format("YYYY-MM"),
          campusId: this.campusId,
          gender: this.userInfo1.gender, //性别 1男 2女 3通用
        };
        const { code, data } = await allotComboCalendar(params);
        if (code == 200) {
          this.allData = data;
          this.defaultDate = this.allData.map((item) => item.allotDate);
          this.courseList = this.allData.map((item) => item.allotDate);
        }
      }
    },
    // 获取日历天数
    getCalendarDay() {
      let year = new Date(this.defaultMonth).getFullYear(); // 当月年份
      let month = new Date(this.defaultMonth).getMonth() + 1; // 当月月份
      let days = new Date(year, month, 0).getDate(); // 当月天数

      let prevYear = month === 1 ? year - 1 : year; // 上一年年份
      let prevMonth = month === 1 ? 12 : month - 1; // 上月月份
      let prevDays = new Date(prevYear, prevMonth, 0).getDate(); // 上一月天数

      let lastYear = month === 12 ? year + 1 : year; // 下一年年份
      let lastMonth = month === 12 ? 1 : month + 1; // 下月月份
      // let lastDays = new Date(lastYear, lastMonth, 0).getDate() // 下一月天数

      let prevMonthArr = []; // 上月数据
      let nextMonthArr = []; // 下月数据
      let currentMonthArr = []; // 当月数据
      // 判断当月1号是星期几
      let firstDay = new Date(year, month - 1, 1).getDay();
      // 获取显示上月的数据
      for (let i = 0; i < firstDay; i++) {
        let day = prevDays - firstDay + (i + 1);
        let day2 = day >= 10 ? day : "0" + day;
        let month2 = prevMonth >= 10 ? prevMonth : "0" + prevMonth;
        prevMonthArr.push({
          year: prevYear,
          month: prevMonth,
          month2: month2,
          day: day,
          day2: day2,
          date: `${prevYear}-${prevMonth}-${day}`,
          date2: `${prevYear}-${month2}-${day2}`,
          include: false,
        });
      }
      // 获取显示的下一月的数据
      for (let i = 0; i < 42 - firstDay - days; i++) {
        let day = i + 1;
        let day2 = day >= 10 ? day : "0" + day;
        let month2 = lastMonth >= 10 ? lastMonth : "0" + lastMonth;
        nextMonthArr.push({
          year: lastYear,
          month: lastMonth,
          month2: month2,
          day: day,
          day2: day2,
          date: `${lastYear}-${lastMonth}-${day}`,
          date2: `${lastYear}-${month2}-${day2}`,
          include: false,
        });
      }
      // 获取当月显示数据
      for (let i = 1; i <= days; i++) {
        let day2 = i >= 10 ? i : "0" + i;
        let month2 = month >= 10 ? month : "0" + month;
        currentMonthArr.push({
          year: year,
          month: month,
          month2: month2,
          day: i,
          day2: day2,
          date: `${year}-${month}-${i}`,
          date2: `${year}-${month2}-${day2}`,
          include: true,
        });
      }

      this.calendarData = [
        ...prevMonthArr,
        ...currentMonthArr,
        ...nextMonthArr,
      ];
    },
    // 设置默认值
    setDefaultValue(date) {
      if (!date) {
        this.activeData = null;
        return;
      }
      let year = new Date(date).getFullYear(); // 当月年份
      let month = new Date(date).getMonth() + 1; // 当月月份
      let month2 = month >= 10 ? month : "0" + month;
      let day = new Date(date).getDate();
      let day2 = day >= 10 ? day : "0" + day;
      let row = {
        year: year,
        month: month,
        month2: month2,
        day: day,
        day2: day2,
        date: `${year}-${month}-${day}`,
        date2: `${year}-${month2}-${day2}`,
        include: true,
      };
      this.clickDay(row);
    },
    async clickDay(row) {
      //无号源
      let index = this.allData.findIndex((e) => {
        return e.allotDate === row.date2 && e.remainderQuantity>0;
      });
      if (index == -1) {
        return false;
      }

      if (this.type === "portion" && !row.include) {
        // this.$message.warning('只能选择当前月份的日期')
        return;
      }
      this.activeData = { ...row };
      this.$emit("clickDate", { ...row });
      const params = {
        comboId: this.queryParams && this.queryParams.id,
        someday: this.activeData.date2,
        campusId: this.campusId,
        gender: this.userInfo1.gender, //性别 1男 2女 3通用
      };
      const { code, data } = await getAllotTimePeriod(params);
      if (code == 200) {
        this.sourceList = data;
      }

      let week = ["日", "一", "二", "三", "四", "五", "六"][
        new Date(this.activeData.date2).getDay()
      ];
      this.visibleTitle = `${this.activeData.date2} 周${week}`;
      this.visible = true;
    },
    doConfirmation(item) {
      const params = {
        ...this.queryParams,
        campusName: this.campusName,
        dateStr: this.activeData.date2,
        campusNo: this.campusId,
        ...item,
      };
      this.$router.push({
        path: "/confirmation",
        query: {
          type: "physical",
          physicalParams: JSON.stringify(params),
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.calendar-box {
  background-color: #f6f6f6 padding 10px;
  .calendar-table {
    width: 100%;
    border-radius: 4px;
    display: block;
    overflow: hidden;
    thead,
    tbody {
      display: flex;
      width: 100%;
    }
    tr {
      width: 100%;
    }
    th {
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #3e597b;
      box-sizing: border-box;
      display: inline-block;
      width: 14.28%;
    }
    td {
      width: 14.28%;
      display: inline-block;
      position: relative;
      font-size: 16px;
      font-weight: 500;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
      border: solid 2px transparent;
      color: rgba(62, 89, 123, 0.3);
      background-color: #f5f5f5;
      padding: 5px;
      & > .includeContent {
        border: 1px solid #ddd;
        height: 80px;
        &.include {
          color: #3e597b;
          background-color: #fff;
        }
        &.active {
          border: 2px solid #0176f6;
          background: #0176f6;
          color: #fff;
        }
      }
      .day {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        & > .d_one {
          position: absolute;
          top: 5px;
          left: 15px;
        }
        & > .d_two {
          position: absolute;
          top: 5px;
          right: 5px;
        }
        & > .d_three {
          width: 100%;
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
        }
      }
      &:nth-child(1),
      &:nth-child(7),
      &:nth-child(8),
      &:nth-child(14),
      &:nth-child(15),
      &:nth-child(21),
      &:nth-child(22),
      &:nth-child(28),
      &:nth-child(29),
      &:nth-child(35),
      &:nth-child(36),
      &:nth-child(42) {
        background: #f6f6f6; //根据自己需要，设置td周末的背景颜色
      }
    }
    tbody {
      .clickDay {
        border: solid 2px #00bbbb;
      }
    }
  }
}

/deep/ .modalstyle {
  .ant-modal-body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow-y: auto;

    .source-span {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    > span {
      width: 45%;
    }

    .item-btn-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 12px;
      // width: 210px;
      // box-sizing: border-box;
      border-bottom: 1px solid #faf7fa;
      .time {
        font-size: 14px;
        padding: 0 10px;
      }
    }
    .auto-m {
      position: relative;
      left: 60%;
    }
  }
}
</style>
